class VariantTitle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('variant:change', (event) => {
      this.updateTitle(event);
    });
    document.addEventListener('DOMContentLoaded', () => {
      this.defaultTitle = this.textContent;
    });
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.updateTitle);
  }

  updateTitle(event) {
    const variant = event.detail.variant;
    if (variant && variant.title && variant.title !== 'Default Title') {
      this.textContent = variant.title;
    } else {
      this.textContent = this.defaultTitle;
    }
  }
}

if (!window.customElements.get('variant-title')) {
  window.customElements.define('variant-title', VariantTitle);
}
